import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonService } from 'src/app/lib/services/common.service';
import { LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'app-crop-image',
  templateUrl: './crop-image.component.html',
  styleUrls: ['./crop-image.component.scss'],
  standalone: false
})
export class CropImageComponent implements OnInit {

  @Input() imageBase64: any;
  croppedImageBase64: any;
  isLoading: any;

  constructor(
    private modelCtrl: ModalController,
    private commonService: CommonService
  ) { }

  async ngOnInit() {
    this.isLoading = await this.commonService.presentLoader();
    this.isLoading.present();
  }

  onImageCropped(event: any) {
    this.croppedImageBase64 = event.base64;
  }

  async onImageLoaded(event: LoadedImage) {
    if (event) {
      await this.isLoading.dismiss();
    }
  }

  saveCroppedImage() {
    this.modelCtrl.dismiss(this.croppedImageBase64);
  }

  cancel() {
    this.modelCtrl.dismiss("close");
  }
}
